import styles from './styles.module.scss';
import Typography from '@components/common/typography';
import Button from '@components/common/button';
import { useState } from 'react';
import Checkbox from '@components/common/checkbox';
import { apiAccountService } from '@api';
import { useLocales } from '@hooks/helpers/useLocales';
import { useUserContext } from '@hooks/context/useUserContext';
import { EDdrStatus } from '@xeppt/xeppt-sdk/types';
import { useApiQuery } from '@hooks/api/useApiQuery';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import { pageAnimation } from '@const/animation';
import { useInteracModals } from '@hooks/modals/useInteracModals';
import { Link } from 'react-router-dom';
import { routes } from '@const/routes';
import InfoBlock from '@components/common/info_block';
import { useNavigationContext } from '@hooks/context/useNavigationContext';

const ManageAutodepositSection = () => {
    const { t } = useTranslation('sections', {
        keyPrefix: 'send_and_request.manage_autodeposit'
    });
    const [isUpdate, setIsUpdate] = useState(false);
    const { user } = useUserContext();
    const { handleChangeInteracEmail } = useInteracModals();
    const [isAgree, setIsAgree] = useState(false);
    const { submitLocale } = useLocales();
    const { handleBack } = useNavigationContext();

    // const { handleRequest: onSetAutodeposit, isLoading } = useApiMutation({
    //     method: () => {
    //         return new Promise((res) => {
    //             apiAccountService.requestETransferDdr();
    //             setTimeout(() => {
    //                 res('ok');
    //             }, 2000);
    //         });
    //     },
    //     onSuccess: () => {
    //         requestSuccessLocale('set_ddr');
    //         refetchAccount();
    //         handleOpenRequestAutodepositModal((val) => setIsUpdate(val));
    //     },
    //     onError: requestErrorLocale
    // });

    const { data: ddrStatus } = useApiQuery({
        method: () => apiAccountService.checkETransferDdr()
    });

    return (
        <motion.div {...pageAnimation} className={styles.wrapper}>
            <div className={styles.header}>
                <Button
                    className={styles.back}
                    variant="text-gray"
                    leftIcon="arrow_left"
                    onClick={handleBack}>
                    {submitLocale('back')}
                </Button>
                <Typography variant="h4">{t('title')}</Typography>
            </div>
            <div className={styles.content}>
                <Typography variant="body3" className={styles.description}>
                    {t('description')}
                </Typography>
                <div className={styles.email_wrapper}>
                    <div className={styles.left}>Interac email address</div>
                    <div className={styles.right}>
                        {user?.profile?.first_name} {user?.profile?.last_name} (
                        {/*{account?.etransfer_account?.interac_email})*/}
                        <Button leftIcon="edit" onClick={handleChangeInteracEmail} />
                    </div>
                </div>
                {isUpdate ? (
                    <>
                        <motion.div {...pageAnimation} className={styles.agreement}>
                            <div
                                className={styles.form_row}
                                onClick={() => setIsAgree((state) => !state)}>
                                <Checkbox
                                    className={styles.checkbox}
                                    checked={isAgree}
                                    onClick={() => setIsAgree((state) => !state)}
                                />
                                <Typography className={styles.send_disclaimer}>
                                    <span>{t('agree_1')}</span>
                                    <br />
                                    {t('agree_2')} <span>{t('agree_3')}</span> {t('agree_4')}
                                    <br />
                                    <br />
                                    {t('agree_5')}
                                    <br />
                                    <br />
                                    {t('agree_6')}{' '}
                                    <Link to={routes.privacy_policy}>{t('agree_7')}</Link>
                                </Typography>
                            </div>
                        </motion.div>
                        {/*<Button
                            variant="primary"
                            onClick={() => onSetAutodeposit(undefined)}
                            isLoading={isLoading}
                            disabled={!isAgree}>
                            {submitLocale('save')}
                        </Button>*/}
                    </>
                ) : (
                    <Button variant="primary" onClick={() => setIsUpdate(true)}>
                        {t('set_up')}
                    </Button>
                )}
                {ddrStatus === EDdrStatus.PENDING && (
                    <InfoBlock variant="warning">
                        <Typography variant="body4" fw={600}>
                            Confirmation is pending
                        </Typography>
                        <Typography variant="body4">
                            You’ve started your Autodeposit setup, but it’s not yet complete. Please
                            check your email for a verification message from Interac®. You must
                            confirm within 24 hours of when the email was sent. Otherwise, your
                            request will be canceled and you’ll need to start over.
                        </Typography>
                    </InfoBlock>
                )}
            </div>
        </motion.div>
    );
};

export default ManageAutodepositSection;
